module.exports = __webpack_public_path__ + "img/btnCard-7.ccb0034f.jpg";